<script lang="ts">
  import Button from '../ui/Button.svelte';
  import Card from '../ui/Card.svelte';
  import { ROOM_CODE_LENGTH, type GameConfig } from '../../shared/config';
  import GameSettings from '../panels/GameSettings.svelte';
  import { getSession } from '../session/context';

  interface Props {
    screen: 'host' | 'join';
    createRoom: () => Promise<void>;
    joinRoom: () => Promise<void>;
    updateConfig: (patch: Partial<GameConfig>) => void;
  }
  let { screen, createRoom, joinRoom, updateConfig }: Props = $props();
  const session = getSession();
</script>

<section id="screen-join" class="screen">
  <h1>{screen === 'host' ? 'Host a room' : 'Join a room'}</h1>
  <Card
    as="form"
    autocomplete="off"
    onsubmit={(event) => {
      event.preventDefault();
      void (screen === 'host' ? createRoom() : joinRoom());
    }}
  >
    {#if screen === 'join'}<label for="roomInput">Room code</label>
      <input
        id="roomInput"
        value={$session.roomInput}
        oninput={(event) => session.setRoomInput(event.currentTarget.value)}
        maxlength={ROOM_CODE_LENGTH}
        placeholder="ABC123"
        aria-describedby="joinStatus"
      />{/if}
    {#if screen === 'host'}<GameSettings
        config={$session.hostConfig}
        editable={!$session.creatingRoom && !$session.joiningRoom}
        change={updateConfig}
      />{/if}
    <Button
      variant="primary"
      size="big"
      full
      type="submit"
      aria-busy={$session.creatingRoom || $session.joiningRoom}
      disabled={$session.creatingRoom ||
        $session.joiningRoom ||
        ($session.joined && !$session.reconnectStopped)}
      >{$session.creatingRoom
        ? 'Creating a Room…'
        : $session.joiningRoom
          ? 'Joining Room…'
          : screen === 'host'
            ? 'Create'
            : $session.reconnectStopped
              ? 'Take Over This Tab'
              : 'Join Room'}</Button
    >
    <p id="joinStatus" class="status" role="status">{$session.joinStatus}</p>
  </Card>
</section>

<style>
  #screen-join {
    justify-content: center;
    gap: 8px;
    padding-bottom: 8vh;
  }
</style>
